export default {
  title: '이제 이 페이지를 닫으셔도 됩니다. 질문이 있으시면 언제든지 저희에게 전화해 주세요:',
  'call-rating': '통화 평가',
  comment: {
    title: '의견을 남겨주세요:',
    placeholder: '모든 것이 마음에 드셨는지, 기대와 인상을 적어주세요',
    error: '평점을 낮게 주셨다면 무엇이 문제였는지 설명해주세요.',
    'send-btn': '보내기',
  },
  'accepted-message': '고객님의 피드백이 접수되었습니다. 저희 배달 서비스를 이용해 주셔서 감사합니다!',
}
